import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Ad creator payments tab. List and receipt upload will be added with API.
 */
const AdsPayments = () => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Payments
      </Typography>
      <Typography color="text.secondary">
        Payment history and receipt upload will be added here.
      </Typography>
    </Box>
  );
};

export default AdsPayments;
